export const getPaymentUrl = (payment) => {
  if (!payment) return "";
  return payment.payment_url || payment.paymentPageUrl || payment.paymentUrl || payment.url || "";
};

export const isEmbeddedPaymentBrowser = () => {
  if (typeof navigator === "undefined") return false;

  const ua = `${navigator.userAgent || ""} ${navigator.vendor || ""}`.toLowerCase();

  return [
    "instagram",
    "fb_iab",
    "fban",
    "fbav",
    "line/",
    "twitter",
    "tiktok",
    "; wv",
    "webview",
    "iabmv"
  ].some((item) => ua.includes(item));
};

export const getPaymentBrowserInfo = () => {
  if (typeof navigator === "undefined") {
    return {
      embedded: false,
      user_agent: "",
      platform: "",
      vendor: "",
      language: "",
      current_url: "",
      referrer: ""
    };
  }

  return {
    embedded: isEmbeddedPaymentBrowser(),
    user_agent: navigator.userAgent || "",
    platform: navigator.platform || "",
    vendor: navigator.vendor || "",
    language: navigator.language || "",
    current_url: typeof window !== "undefined" ? window.location.href : "",
    referrer: typeof document !== "undefined" ? document.referrer : "",
    visibility_state: typeof document !== "undefined" ? document.visibilityState : ""
  };
};

export const canAutoRedirectPayment = () => true;

export const getPaymentRedirectCopy = (method) => {
  const isSnapp = method === "snapp_pay";
  const embedded = isEmbeddedPaymentBrowser();

  return {
    title: isSnapp ? "انتقال به پرداخت اعتباری" : "انتقال به درگاه پرداخت",
    message: embedded
      ? "در حال تلاش برای باز کردن صفحه پرداخت هستیم. اگر باز نشد، روی دکمه ادامه پرداخت بزنید."
      : "در حال انتقال به صفحه پرداخت هستید. اگر انتقال خودکار انجام نشد، روی دکمه زیر بزنید.",
    help: embedded ? "اگر داخل اینستاگرام هستید و پرداخت باز نشد، لینک را کپی کنید و در Chrome یا Safari باز کنید." : "",
    embedded
  };
};

export const goToPaymentUrl = (url) => {
  if (!url || typeof window === "undefined") return;

  try {
    window.location.assign(url);
  } catch {
    window.location.href = url;
  }
};

export const copyPaymentUrl = async (url) => {
  if (!url || typeof navigator === "undefined") return false;

  try {
    await navigator.clipboard.writeText(url);
    return true;
  } catch {
    return false;
  }
};
